import { cardStore, updateNowPlayingCard } from "@/stores/nowPlayingStore";
import { Songcard } from "@/types";
import { Box, Heading, Spinner, useColorMode } from "@chakra-ui/react";
import { useStore } from "@tanstack/react-store";
import { BiPause, BiPlay } from "react-icons/bi";
import { useAudioPlayer } from "react-use-audio-player";

interface PlayBoxProps {
  card: Songcard;
}

export default function PlayBox({ card }: PlayBoxProps) {
  const { colorMode } = useColorMode();
  const { togglePlayPause, loading, playing } = useAudioPlayer();
  const cardPlaying = useStore(cardStore, (state) => state);

  const handlePlayback = () => {
    if (cardPlaying.card.uuid != card.uuid) {
      updateNowPlayingCard(card);
    } else {
      togglePlayPause();
    }
  };

  return (
    <>
      <Box
        border="1px solid #ccc"
        borderRadius={10}
        p={3}
        display="flex"
        alignItems="center"
        style={{ cursor: "pointer" }}
        onClick={() => handlePlayback()}
        borderColor={colorMode == "dark" ? "white" : "black"}
        borderStyle="dotted"
        w={270}
      >
        <Heading size="md" flex="1" as="h1" padding={2}>
          {card.title}
        </Heading>
        {(cardPlaying.card.uuid != card.uuid ||
          (cardPlaying.card.uuid == card.uuid && !playing && !loading)) && (
          <div style={{ background: "transparent", border: "none" }}>
            <BiPlay size={30} />
          </div>
        )}
        {cardPlaying.card.uuid == card.uuid && playing && !loading && (
          <div style={{ background: "transparent", border: "none" }}>
            <BiPause size={30} />
          </div>
        )}
        {cardPlaying.card.uuid &&
          loading &&
          cardPlaying.card.uuid == card.uuid && (
            <div style={{ justifyContent: "center", alignItems: "center" }}>
              <Spinner size={"md"} mt={1} mb={0} thickness="3px" />
            </div>
          )}
      </Box>
    </>
  );
}
